import React from 'react'
import FavoritesContainer from './FavoritesContainer'

const Favorites = () => <FavoritesContainer />

export default Favorites
